import { useAtom } from "jotai";
import { type ReactNode, useEffect, useRef } from "react";
import { scrollStateAtom } from "./editorAtoms";
import classNames from "classnames";

const BottomModalHorizontalScroll = ({
  name,
  children,
  className,
}: {
  name: string;
  children: ReactNode;
  className?: string;
}) => {
  const [scrollState, setScrollState] = useAtom(scrollStateAtom);

  const ref = useRef<HTMLDivElement>(null);
  const scrollLeft = useRef(scrollState[name] || 0);

  useEffect(() => {
    const element = ref.current;

    if (element) {
      element.scrollLeft = scrollLeft.current;

      const handleScrollChange = () => {
        setScrollState((prev) => ({ ...prev, [name]: element.scrollLeft }));
        scrollLeft.current = element.scrollLeft;
      };

      element.addEventListener("scroll", handleScrollChange);
      return () => element.removeEventListener("scroll", handleScrollChange);
    }
  }, [setScrollState, ref, name]);

  return (
    <div
      ref={ref}
      className={classNames(
        "flex gap-3 max-w-full overflow-scroll no-scrollbar",
        className
      )}
    >
      {children}
    </div>
  );
};

export default BottomModalHorizontalScroll;
